var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg100HomeActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.04 2.95558C14.4371 2.51481 13.5629 2.51481 12.96 2.95558L3.21 10.0647C2.8395 10.3349 2.625 10.7344 2.625 11.1567V23.9532C2.625 24.738 3.353 25.375 4.25 25.375H10.75V19.6877C10.75 18.9028 11.478 18.2658 12.375 18.2658H15.625C16.522 18.2658 17.25 18.9028 17.25 19.6877V25.375H23.75C24.647 25.375 25.375 24.738 25.375 23.9532V11.1567C25.375 10.7344 25.1605 10.3349 24.79 10.0647L15.04 2.95558Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100HomeActive);
export default __webpack_public_path__ + "static/media/100-home-active.a9a5e9121d7a67e494d65ce3c92d331c.svg";
export { ForwardRef as ReactComponent };